angular.module('gym.mobile_app').directive('mobileAppSettingsDesign', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/mobile_app/design_settings.html.slim'),
    controller: ["$scope", "MobileApp", "flash", function($scope, MobileApp, flash) {
      MobileApp.all('settings').getList().then(function(data) {
        $scope.settings = data[0];
        return $scope.settings.rootObjectName = 'gym_mobile_app_detail';
      });
      $scope.onLogoChange = function(image) {
        $scope.settings.logo_asset_id = image.id;
        return $scope.settings.logo_url = image.thumb_url;
      };
      $scope.onLoginScreenChange = function(image) {
        $scope.settings.login_screen_asset_id = image.id;
        return $scope.settings.login_screen_url = image.thumb_url;
      };
      $scope.onEventHeaderChange = function(image) {
        $scope.settings.event_header_asset_id = image.id;
        return $scope.settings.event_header_url = image.thumb_url;
      };
      $scope.onDefaultProductImageChange = function(image) {
        $scope.settings.default_product_image_asset_id = image.id;
        return $scope.settings.default_product_image_url = image.thumb_url;
      };
      return $scope.save = function() {
        $scope.loading = true;
        return $scope.settings.save().then(function(response) {
          $scope.loading = false;
          $scope.settings = response;
          $scope.settings.rootObjectName = 'gym_mobile_app_detail';
          return flash.success = "Updated successfully";
        }, function() {
          $scope.loading = false;
          return flash.error = "There was an error processing the request.";
        });
      };
    }]
  };
});
